import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { TimelineEntry } from '../types/timeline';

export function useTimelineEntries(contactIds?: string) {
  const [entries, setEntries] = useState<TimelineEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEntries = async () => {
    if (!contactIds) {
      setEntries([]);
      setLoading(false);
      return;
    }

    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_timeline_entries')
        .select('*, contact_id')
        .in('contact_id', contactIds.split(','))
        .order('date', { ascending: false });

      if (fetchError) throw fetchError;
      setEntries(data || []);
    } catch (err) {
      setError('Failed to load timeline entries');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, [contactIds]);

  return { entries, loading, error, refetch: fetchEntries };
}